import styled from 'styled-components';
import colors from 'basic-ui-lib/constants/colors';
import { Col, Ic3Dots, Text } from 'basic-ui-lib';
import { IMediaItem } from 'modules/media/interfaces/api';
import MenuAction from 'basic-ui-lib/components/MenuTabelAction';
import ModalConfirm from 'widgets/ModalConfirm';
import EditNameModal from 'basic-ui-lib/components/Modal/EditNameModal';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';
import { useMediaMoreAction } from 'modules/media/services/hooks/useMediaMoreAction';
import { useMediaQuery } from 'react-responsive';
import MoveToStoresModal from '../MoveToStoreModal';
import MoveToFolderModal from '../MoveToFolderModal';

interface MediaCardProps {
  item: IMediaItem;
  onClick?: () => void;
  currentPath: string;
  onSuccess: (currentPath: string) => void;
  storeId?: string;
}
export const MediaCard = ({
  item,
  onClick,
  currentPath,
  onSuccess,
  storeId,
}: MediaCardProps) => {
  const {
    getListMenu,
    handleMenuClick,
    modalConfirmRef,
    editNameModalRef,
    moveToStoresModalRef,
    moveToFolderModalRef,
  } = useMediaMoreAction({ currentPath, onSuccess, storeId });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <Container>
        <Content>
          <Zone onClick={onClick}>
            <MoreButton
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <MenuAction
                listMenu={getListMenu(item)}
                onClick={(menuItem) => handleMenuClick(menuItem, item)}
              >
                <Ic3Dots width={20} height={20} fill='#777D7C' />
              </MenuAction>
            </MoreButton>
            {RenderMedia(item, 4, false, isMobile ? false : true)}
          </Zone>
        </Content>
        <Col gap={4} width='100%' alignItems='center' paddingBottom={8}>
          <Text
            ellipsis
            content_2
            medium
            style={{ maxWidth: '100%' }}
            userSelect='none'
          >
            {item.name}
          </Text>
          <Text caption_3 regular color='neutral.text.3' userSelect='none'>
            {item.size}
          </Text>
        </Col>
      </Container>
      <ModalConfirm ref={modalConfirmRef} />
      <EditNameModal ref={editNameModalRef} />
      <MoveToStoresModal ref={moveToStoresModalRef} />
      <MoveToFolderModal ref={moveToFolderModalRef} storeId={storeId} onSuccess={onSuccess} currentPath={currentPath} />
    </>
  );
};

const MoreButton = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s,
    visibility 0.2s;

  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${colors.neutral.bg[2]};

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    opacity: 1;
    visibility: visible;
    top: 4px;
    right: 4px;
    width: 28px;
    height: 28px;
    background-color: ${colors.neutral.bg[2]};
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  border: 1px solid ${colors.neutral.bg[3]};
  border-radius: 8px;
  background-color: ${colors.neutral.bg[1]};
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.1);

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    cursor: pointer;
    transform: translateY(-2px);
    border-color: rgba(80, 120, 255, 0.35);
    background-color: #ffffff;
    box-shadow:
      0 8px 20px -8px rgba(0, 0, 0, 0.18),
      0 2px 6px -2px rgba(0, 0, 0, 0.08);
  }

  &:hover ${MoreButton} {
    opacity: 1;
    visibility: visible;
  }

  @media (max-width: 768px) {
    background: ${colors.neutral.bg[1]};
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
`;

const Content = styled.div`
  width: 100%;
  padding: 8px;
  height: 131px;
  background: ${colors.neutral.bg[1]};
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 0px;
    height: 95px;

    .custom-media {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom-left-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }
  }
`;

const Zone = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${colors.neutral.text[3]};
  border-radius: 4px;

  .media-video,
  .media-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    border-radius: 4px;
  }
`;
